import { YunzaiG2Component } from './yunzai-g2.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

@NgModule({
  declarations: [YunzaiG2Component],
  imports: [
  ],
  exports: [YunzaiG2Component]
})
export class YunzaiG2Module {
  public static forRoot(p: any) {
    return {
      ngModule: YunzaiG2Module,
      providers: [
        // { provide: URL_VALUE, useValue: p }
      ]
    };
  }
}
